<script setup>
import { reactive } from 'vue'
import FavoriteContentsTop from './Favorite2ContentsTop'
import FavoriteContentsEdit from './Favorite2ContentsEdit'

const props = defineProps({
  category: String,
})

const state = reactive({
  editing: false,
})

const categoryJ = props.category === 'brand' ? 'ブランド' : 'ストア'
</script>

<template>
  <div class="w-full">
    <transition name="slide-right2">
      <template v-if="!state.editing"><FavoriteContentsTop :category="props.category" :category-j="categoryJ" @change="state.editing = true" /></template>
    </transition>

    <transition name="slide-left2">
      <template v-if="state.editing"><FavoriteContentsEdit :category="props.category" :category-j="categoryJ" @change="state.editing = false" /></template>
    </transition>
  </div>
</template>
